import React, { ReactNode, useMemo, useState } from 'react';

import { Box, CopyToClipboard } from '@explorer/core';

/**
 * CellCopy
 */
export const CellCopy = ({
  children,
  copyMe,
  size = 'small',
}: CellCopyProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const isCopyDisabled = useMemo(() => {
    if (!copyMe) return true;
    return copyMe === '-';
  }, [copyMe]);

  return (
    <Box
      alignItems="center"
      display="flex"
      flex={1}
      minWidth={0}
      maxWidth="100%"
      width="100%"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Box flex={1} minWidth={0}>
        {children}
      </Box>
      <Box
        display="flex"
        ml="auto"
        pl={0.5}
        sx={{
          opacity: isHovered && !isCopyDisabled ? 1 : 0,
          pointerEvents: isHovered && !isCopyDisabled ? 'auto' : 'none',
          transition: 'opacity 120ms ease-in-out',
        }}
      >
        <CopyToClipboard copyMe={copyMe ?? ''} size={size} />
      </Box>
    </Box>
  );
};

/**
 * CellCopy Props
 */
export interface CellCopyProps {
  children: ReactNode;
  copyMe?: string;
  size?: 'small' | 'medium';
}
